import type { MotionProps } from 'framer-motion';
import {
  buildHiddenVariant,
  buildVisibleVariant,
} from '@/components/animations';

const visible = buildVisibleVariant({ transition: { duration: 0.75 } });

/*
 * Header
 */
export const headerMotionProperties: MotionProps = {
  initial: 'hidden',
  variants: {
    hidden: buildHiddenVariant(),
    visible: buildVisibleVariant({ transition: { staggerChildren: 0.3 } }),
  },
  viewport: { once: true },
  whileInView: 'visible',
};

/*
 * Child Element
 */
const CHILD_ELEMENT_OFFSET_Y = -50;

export const childElementMotionProperties: MotionProps = {
  variants: {
    hidden: buildHiddenVariant({ y: CHILD_ELEMENT_OFFSET_Y }),
    visible,
  },
};

/*
 * Mobile Child Element
 */
const MOBILE_CHILD_ELEMENT_OFFSET_X = 50;

export const mobileChildElementMotionProperties: MotionProps = {
  variants: {
    hidden: buildHiddenVariant({ x: MOBILE_CHILD_ELEMENT_OFFSET_X }),
    visible,
  },
};
